import { render, staticRenderFns } from "./ListadoEvento.vue?vue&type=template&id=67683baa&scoped=true"
import script from "./ListadoEvento.vue?vue&type=script&lang=js"
export * from "./ListadoEvento.vue?vue&type=script&lang=js"
import style0 from "./ListadoEvento.vue?vue&type=style&index=0&id=67683baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67683baa",
  null
  
)

export default component.exports